export const studioCalendarEn = {
  'Single Timeline': 'Single Timeline',
  'Multi-Room Timeline': 'Multi-Room Timeline',
  'Day Off': 'Day Off',
  'Outside Hours': 'Outside Hours',
  'Booked': 'Booked',
  'Legend': 'Legend',
  'Engineer Availability': 'Engineer Availability',
  // Recurrence
  'Repeat this booking': 'Repeat this booking',
  'Every week': 'Every week',
  'Every 2 weeks': 'Every 2 weeks',
  'Every month': 'Every month',
  'Frequency': 'Frequency',
  'After': 'After',
  'sessions': 'sessions',
  'Until': 'Until',
  '{{count}} bookings will be created': '{{count}} bookings will be created',
  'Total for series': 'Total for series',
  'Create {{count}} Bookings': 'Create {{count}} Bookings',
  '{{count}} bookings created successfully': '{{count}} bookings created successfully',
  // Rescheduling
  'Confirm Reschedule': 'Confirm Reschedule',
  'From': 'From',
  'To': 'To',
  'The customer will be notified of this time change.': 'The customer will be notified of this time change.',
  'Booking rescheduled successfully': 'Booking rescheduled successfully',
  'Failed to reschedule booking': 'Failed to reschedule booking',
  'Move': 'Move',
  'Move Mode': 'Move Mode',
  'Switch to view mode': 'Switch to view mode',
  'Switch to move mode — drag bookings to reschedule': 'Switch to move mode — drag bookings to reschedule',
};
